import { Button, Flex, getSpace, Typography, useToast } from "@aircall/tractor";
import styled from "@xstyled/styled-components";
import { useTranslation } from "react-i18next";
import ThumbDown from "@/assets/thumb_down.svg?react";
import ThumbUp from "@/assets/thumb_up.svg?react";
import { useCall } from "@/hooks/useCall/useCall";
import { useTrack } from "@/hooks/useTrack/useTrack";
import { useIsFeedbackSent } from "@/states/feedbackSent/feedbackSent";

const SButton = styled(Button)`
  margin: 0;
  gap: ${getSpace("xxxs")};
`;

export function TranscriptionFeedbackButtons() {
  const { t } = useTranslation();
  const { markFeedbackAsSent } = useIsFeedbackSent();
  const { track } = useTrack();
  const toast = useToast();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  const payLoad = {
    transcription_id: call.transcription?.transcriptionId,
    call_uuid: call.uuid,
    call_direction: call.direction,
    call_type: call.type,
  };

  const onThumbDownClick = () => {
    track("transcription_rated_bad", payLoad);
    markFeedbackAsSent();
  };
  const onThumbUpClick = () => {
    track("transcription_rated_good", payLoad);
    toast.showToast({
      variant: "success",
      message: t("toast.transcription_quality_message"),
      dismissIn: 3000,
      icon: true,
    });
    markFeedbackAsSent();
  };

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      py="xs"
      data-test="transcription-feedback-buttons"
    >
      <Typography variant="bodySemiboldS">
        {" "}
        {t("transcription-quality-title")}
      </Typography>
      <Flex gap="s">
        <SButton
          mode="link"
          onClick={onThumbUpClick}
          data-test="good-quality-button"
        >
          <ThumbUp /> {t("transcription-good-quality-button")}
        </SButton>
        <SButton
          mode="link"
          variant="critical"
          onClick={onThumbDownClick}
          data-test="bad-quality-button"
        >
          <ThumbDown /> {t("transcription-bad-quality-button")}
        </SButton>
      </Flex>
    </Flex>
  );
}
